import updateTodayDate from '../actions/updateTodayDate';
import { mailStore } from 'owa-mail-store';
import addDays from 'date-fns/add_days';
import isSameDay from 'date-fns/is_same_day';
import isWithinRange from 'date-fns/is_within_range';
import { adjustDateTimeToTimezone, formatDate } from 'owa-datetime-format';
import getTimeZoneOffset from 'owa-datetime-store/lib/utils/getTimeZoneOffset';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { select } from 'satcheljs/lib/legacy';
import { now } from 'owa-datetime/lib/displaydate/now';
export default select({
    todayDate: function () { return mailStore.todayDate; },
})(function getFormattedDate(dateTimeISOString, isLongDate, state) {
    if (isLongDate === void 0) { isLongDate = false; }
    if (!state.todayDate || state.todayDate.getDate() != now().getDate()) {
        // This is fallback logic to update Today date if the one in store is not correct.
        updateTodayDate();
    }
    var configDateFormat = getUserConfiguration().UserOptions.DateFormat;
    var configTimeFormat = getUserConfiguration().UserOptions.TimeFormat;
    var today = state.todayDate;
    var parsedDateTime = Date.parse(dateTimeISOString);
    if (isNaN(parsedDateTime)) {
        throw Error("Invalid dateTimeISOString: " + dateTimeISOString);
    }
    var displayDate = new Date(parsedDateTime);
    // adjust display to user time zone
    var adjustedDateWithoutTime = adjustDateTimeToTimezone(displayDate, getTimeZoneOffset(displayDate));
    adjustedDateWithoutTime.setHours(0, 0, 0, 0);
    var configFormatString;
    if (isLongDate) {
        configFormatString = 'ddd ' + configDateFormat + ', ' + configTimeFormat;
    }
    else if (isSameDay(adjustedDateWithoutTime, today)) {
        configFormatString = configTimeFormat;
    }
    else if (isWithinRange(adjustedDateWithoutTime, addDays(today, -3), today)) {
        // If it is in the last 3 days: show day and time. Ex: Thu 11:30am
        configFormatString = 'ddd ' + configTimeFormat;
    }
    else if (isWithinRange(adjustedDateWithoutTime, addDays(today, -30), today)) {
        // If it is in the last 30 days: show day and no year. Ex: Thu 11/10
        // the first regex remove the year values, the next one trims all the non-alphanumberic
        // chars from the string. See:
        // http://stackoverflow.com/questions/18250734/how-to-trim-all-non-alphanumeric-characters-from-start-and-end-of-a-string-in-ja
        configFormatString =
            'ddd ' + configDateFormat.replace(/y/g, '').replace(/^[^a-z\d]*|[^a-z\d]*$/gi, '');
    }
    else {
        configFormatString = configDateFormat;
    }
    return formatDate(displayDate, configFormatString);
});
//# sourceMappingURL=getFormattedDate.js.map